// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminPdfCatalogue = (client) => ({
    /**
     * `GET /admin/pdf-catalogue/documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPdfCatalogueDocuments
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/admin/pdf-catalogue/documents/route.ts
     */
    listDocuments: (query, headers) => client.fetch("/admin/pdf-catalogue/documents", { method: "GET", query, headers }),
    /**
     * `GET /admin/pdf-catalogue/history`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPdfCatalogueHistory
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/admin/pdf-catalogue/history/route.ts
     */
    retrieveHistory: (query, headers) => client.fetch("/admin/pdf-catalogue/history", { method: "GET", query, headers }),
    /**
     * `POST /admin/pdf-catalogue/find-match`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPdfCatalogueFindMatch
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/admin/pdf-catalogue/find-match/route.ts
     */
    updateFindMatch: (body, query, headers) => client.fetch("/admin/pdf-catalogue/find-match", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/pdf-catalogue/image-import`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPdfCatalogueImageImport
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/admin/pdf-catalogue/image-import/route.ts
     */
    updateImageImport: (body, query, headers) => client.fetch("/admin/pdf-catalogue/image-import", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/pdf-catalogue/process-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPdfCatalogueProcessUrl
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/admin/pdf-catalogue/process-url/route.ts
     */
    updateProcessUrl: (body, query, headers) => client.fetch("/admin/pdf-catalogue/process-url", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/pdf-catalogue/upload`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPdfCatalogueUpload
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/admin/pdf-catalogue/upload/route.ts
     */
    upload: (body, query, headers) => client.fetch("/admin/pdf-catalogue/upload", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=pdf-catalogue.js.map